import React, { useState } from 'react';
import { VENDOR_TYPES } from 'pages/Vendor/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import CommonVendor from '../CommonVendor';
import VendorDropdownLists from '../VendorDropdownLists';

const IndianVendor = ({
  toggleDeleteRecord,
  handleClickEdit,
  drawerEmailToggle,
  toggleDeactivatePlan,
  dateRange,
}) => {
  const [selectedKycStatus, setSelectedKycStatus] = useState({
    value: 'All',
    label: 'All',
  });
  const [selectedSubscriber, setSelectedSubscriber] = useState({
    value: 'All',
    label: 'All',
  });
  const [selectedPlanExpiring, setSelectedPlanExpiring] = useState(null);
  const [selectedOsType, setSelectedOsType] = useState({
    value: 'All',
    label: 'All',
  });
  const [selectedRole, setSelectedRole] = useState({
    value: 'All',
    label: 'All',
  });

  return (
    <div>
      <VendorDropdownLists
        selectedSubscriber={selectedSubscriber}
        setSelectedSubscriber={setSelectedSubscriber}
        selectedKycStatus={selectedKycStatus}
        setSelectedKycStatus={setSelectedKycStatus}
        selectedPlanExpiring={selectedPlanExpiring}
        setSelectedPlanExpiring={setSelectedPlanExpiring}
        selectedOsType={selectedOsType}
        setSelectedOsType={setSelectedOsType}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
      />

      <ErrorBoundary>
        <CommonVendor
          kycStatus={selectedKycStatus?.value}
          subscriberType={selectedSubscriber?.value}
          planExpiringType={selectedPlanExpiring?.value}
          osType={selectedOsType?.value}
          traderType={selectedRole?.value}
          type={VENDOR_TYPES.INDIAN}
          handleClickEdit={handleClickEdit}
          toggleDeleteRecord={toggleDeleteRecord}
          drawerEmailToggle={drawerEmailToggle}
          toggleDeactivatePlan={toggleDeactivatePlan}
          dateRange={dateRange}
        />
      </ErrorBoundary>
    </div>
  );
};

export default IndianVendor;
